import React from "react";
import { startTransition } from "react";
import { useNavigate } from "react-router-dom";

const CustomNav = () => {
  const navigate = useNavigate();

  const handleClick = (event) => {
    startTransition(() => {
      navigate("/dashboard");
    });
  };
  return (
    <div>
      <nav
        className={`navbar navbar-expand-lg py-lg-0 fixed-top px-lg-5 `}
        style={{ backgroundColor: "#000000" }}
      >
        <a href="/" className="navbar-brand ms-4 ms-lg-0">
          <img
            className=""
            src="/assets/img/agrani-logo.png"
            alt="Capital for Farmers"
            style={{ height: "40px" }}
          />
        </a>
        <div className="d-lg-none d-md-none px-2">
          <div className="d-flex">
            <div className=" ms-2">
              <a
                className="btn btn-outline-primary py-2 px-3 fs-6 text-decoration-none sign-in"
                onClick={handleClick}
                style={{
                  borderRadius: "5px",
                }}
              >
                Sign In
              </a>
            </div>
            <div className=" ms-2">
              <a
                className="btn text-white py-2 px-3 fs-6 text-decoration-none bg-orange"
                href="https://onboarding.agrani.io"
              >
                Create Account
              </a>
            </div>
          </div>
        </div>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto p-4 p-lg-0 fs-6">
            <a href="/" className="nav-item nav-link  text-decoration-none">
              Home
            </a>
            <a
              href="/contact"
              className="nav-item nav-link  text-decoration-none"
            >
              Contact
            </a>
          </div>

          <div className="d-none d-lg-flex ms-2">
            <a
              className="btn btn-outline-primary py-2 px-3 fs-6 text-decoration-none sign-in"
              onClick={handleClick}
              style={{
                borderRadius: "5px",
              }}
            >
              Sign In
            </a>
          </div>
          <div className="d-none d-lg-flex ms-2">
            <a
              className="btn text-white py-2 px-3 fs-6 text-decoration-none bg-orange"
              href="https://onboarding.agrani.io"
            >
              Create Account
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default CustomNav;
